import type { ApiConfig } from '../../types'

export const spotTradeHistoryApiConfig = {
  existSubType: true,
  fetchableRange: undefined,
  limit: 1000,
  order: 'desc',
  range: undefined,
  requiresRange: false,
  type: 'spot-trade-history',
} as const satisfies ApiConfig
